import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatorModule } from '../translator/translator.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatorModule],
    exports: [FormsModule, ReactiveFormsModule, TranslatorModule],
})
export class DependencyModule {}
